export const CUSTOMERS: string[] = [
  "GM Flint",
  "GM Silao",
  "GM SLP",
  "Stellantis SHAP",
  "Forvia Moldados",
  "Hydro Magnor",
  "DBS Dublin",
  "Wheelme Fredrikstad"
];

